import React from "react";
import { useTranslation } from "react-i18next";

export const AvisoPrivacidad = () => {
  const [t] = useTranslation("global");

  return (
    <section className="wrapper_legals">
      <div className="box_tittle">
        <div className="container">
          <h1 className="mb-2 ttls">{t("others.privacy_notice")}</h1>
          <h6 className="ttls_small">
            AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES RED VOUCHER
            SYSTEMS COLOMBIA, S.A.S.{" "}
          </h6>
        </div>
      </div>
      <div className="content_legals">
        <div className="container">
          <p>{t("privacy_policy.legal_p1")}</p>

          <h5>1. {t("privacy_policy.title_1")}</h5>

          <p>{t("privacy_policy.legal_p2")}</p>

          <ul>
            <li>
              <strong>{t("privacy_policy.legal_p3")}</strong>
            </li>
            <li>
              <strong>{t("privacy_policy.legal_p4")}</strong>
            </li>
          </ul>

          <h5>2. {t("privacy_policy.title_2")}</h5>

          <p>{t("privacy_policy.legal_p5")}</p>

          <ul>
            <li>
              <strong>{t("privacy_policy.legal_p6")}</strong>
            </li>
            <li>
              <strong>{t("privacy_policy.legal_p7")}</strong>
            </li>
            <li>
              <strong>{t("privacy_policy.legal_p8")}</strong>
            </li>
            <li>
              <strong>{t("privacy_policy.legal_p9")}</strong>
            </li>
          </ul>

          <h5>3. {t("privacy_policy.title_3")}</h5>

          <p>{t("privacy_policy.legal_p10")}</p>

          <ul>
            <li>{t("privacy_policy.legal_p11")}</li>
            <li>{t("privacy_policy.legal_p12")}</li>
            <li>{t("privacy_policy.legal_p13")}</li>
            <li>{t("privacy_policy.legal_p14")}</li>
            <li>{t("privacy_policy.legal_p15")}</li>
            <li>{t("privacy_policy.legal_p16")}</li>
          </ul>

          <h5>4. {t("privacy_policy.title_4")}</h5>

          <p>{t("privacy_policy.legal_p17")}</p>

          <ul>
            <li>
              <strong>{t("privacy_policy.legal_p18")}</strong>
            </li>
            <li>
              <strong>{t("privacy_policy.legal_p19")}</strong>
            </li>
          </ul>

          <p>{t("privacy_policy.legal_p20")}</p>

          <h5>5. {t("privacy_policy.title_5")}</h5>

          <p>{t("privacy_policy.legal_p21")}</p>
          <p>{t("privacy_policy.legal_p22")}</p>
          <p>{t("privacy_policy.legal_p23")}</p>
          <p>{t("privacy_policy.legal_p24")}</p>
          <p>{t("privacy_policy.legal_p25")}</p>

          <h5>6. {t("privacy_policy.title_6")}</h5>

          <p>{t("privacy_policy.legal_p26")}</p>

          <ul>
            <li>{t("privacy_policy.legal_p27")}</li>
            <li>{t("privacy_policy.legal_p28")}</li>
            <li>{t("privacy_policy.legal_p29")}</li>
            <li>{t("privacy_policy.legal_p30")}</li>
            <li>{t("privacy_policy.legal_p31")}</li>
            <li>{t("privacy_policy.legal_p32")}</li>
            <li>{t("privacy_policy.legal_p33")}</li>
          </ul>

          <p>{t("privacy_policy.legal_p34")}</p>
          <p>{t("privacy_policy.legal_p35")}</p>

          <h5>8. {t("privacy_policy.title_8")}</h5>

          <p>{t("privacy_policy.legal_p36")}</p>
          <p>{t("privacy_policy.legal_p37")}</p>
          <p>{t("privacy_policy.legal_p38")}</p>
        </div>
      </div>
    </section>
  );
};
